module.exports = __webpack_public_path__ + "static/img/bc-yspx.36c12bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-yspx.png
// module id = 8K6l
// module chunks = 0